import axios from 'axios';
import { DonationURL } from '../../../../config/UrlEndPoint';

export const URL = `${DonationURL}`;

export function findBankImport(queryParams) {
    return axios.post(`${URL}bankstatement/find`, queryParams);
}

export function getBankImport(id) {
    return axios.get(`${URL}bankstatement/${id}`);
}

// URL upload file
export function uploadFile(formData) {
    return axios.post(`${URL}bankstatement`, formData);
}

// URL getData berdasarkan bank_statement Import
export function getDataTagById(id, type) {
    return axios.post(`${URL}bankstatement/process/${id}`, { 'type': type });
}

// URL update batch data donatur
export function updateDonatur(payload) {
    return axios.put(`${URL}donation/update_donor`, payload);
}

// URL update batch settle
export function forceSettle(payload, statement_uuid) {
    return axios.put(`${URL}bankstatement/settle`, { id: payload, bank_statement_uuid: statement_uuid });
}

export function identifyDonor(payload) {
    return axios.post(`${URL}bankstatement/identify`, payload)
}

// URL update batch settle
export function forceAllVoid(reason, statement_uuid) {
    return axios.put(`${URL}bankstatement/void_all`, { reason: reason, bank_statement_uuid: statement_uuid });
}

export function forceSelectedVoid(reason, donations) {
    return axios.put(`${URL}bankstatement/void_all`, { reason: reason, donations: donations });
}
// export function forceSettle(id) {
//     return axios.put(`${URL}bankstatement/settle/${id}`);
// }

